omadapp.components.common_answers_methods = {
	initialize: function() {
		var t = this
		t.correction = t.data.correction
		t.score = t.data.score!=null ? Number(t.data.score) : 0
		t.$context.find(".js_body").html(t.data.text)
		t.$context.click(t,t.click)
	},
	click: function(e) {
		trace ("click")
		var t = e.data
		t.resolve()
		e.preventDefault()
		if (t.callback) {
			t.callback(t)
		}

	},
	resolve:function() {
		var t = this;
		t.$context.addClass(t.correction)
		t.$context.addClass("answered")
	}
}